import { styled } from "@linaria/react"


import { AgentMessageContainer } from "@/components/Chat/AgentMessageStyles.ts"
import { MessageText } from "@/components/Chat/MessageStyles.ts"
import { StreamedTextBlock } from "@/components/Chat/StreamedTextBlock.tsx"

import type { AiChatMessageContent } from "@/lib/client/generated/TypeDefinitions.ts"


export const AgentTextMessage = (props: {
  content: AiChatMessageContent.AgentText
  isNew: boolean
  isLast: boolean
  isActive: boolean
}) => {
  return (
    <AgentMessageContainer isActive={props.isActive}>
      <MessageText>
        <StreamedTextBlock
          text={props.content.text}
          isStreamCompleted={props.content.contentStatus !== "InProgress"}
          isNew={props.isNew}
          isStreamed={props.isLast}
        />
      </MessageText>
      {props.content.contentStatus === "Failed" ? <Error>Request failed</Error> : null}
    </AgentMessageContainer>
  )
}

const Error = styled.span`
  color: var(--error-color);
`